import React from "react";

import { Chip } from "./styles";

interface ChipToggleProps {
    active: boolean;
    onClick: () => void;
    // small (36px) — чипы внутри диалога, где полная высота съедает высоту списка.
    size?: "medium" | "small";
    children: React.ReactNode;
}

export const ChipToggle = ({ active, onClick, size = "medium", children }: ChipToggleProps) => (
    <Chip type="button" $active={active} $size={size} onClick={onClick}>
        {children}
    </Chip>
);
